import { render, staticRenderFns } from "./ElMenuItem.vue?vue&type=template&id=ca411570"
import script from "./ElMenuItem.vue?vue&type=script&lang=js"
export * from "./ElMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports